export class KeyCode {

    public static keyCode(e: KeyboardEvent): number {
        return e.keyCode;
    }

    public static is(e: KeyboardEvent, ...codes: number[]): boolean {
        var code = this.keyCode(e);
        for (var c of codes) {
            if (c === code) {
                return true;
            }
        }
        return false;
    }

    public static BACKSPACE = 8;
    public static TAB = 9;
    public static ENTER = 13;
    public static SHIFT = 16;
    public static CTRL = 17;
    public static ALT = 18;
    public static PAUSE = 19;
    public static CAPS_LOCK = 20;
    public static ESCAPE = 27;
    public static SPACE = 32;
    public static PAGE_UP = 33;
    public static PAGE_DOWN = 34;
    public static END = 35;
    public static HOME = 36;
    public static LEFT_ARROW = 37;
    public static UP_ARROW = 38;
    public static RIGHT_ARROW = 39;
    public static DOWN_ARROW = 40;
    public static INSERT = 45;
    public static DELETE = 46;
    public static KEY_0 = 48;
    public static KEY_1 = 49;
    public static KEY_2 = 50;
    public static KEY_3 = 51;
    public static KEY_4 = 52;
    public static KEY_5 = 53;
    public static KEY_6 = 54;
    public static KEY_7 = 55;
    public static KEY_8 = 56;
    public static KEY_9 = 57;
    public static KEY_A = 65;
    public static KEY_B = 66;
    public static KEY_C = 67;
    public static KEY_D = 68;
    public static KEY_E = 69;
    public static KEY_F = 70;
    public static KEY_G = 71;
    public static KEY_H = 72;
    public static KEY_I = 73;
    public static KEY_J = 74;
    public static KEY_K = 75;
    public static KEY_L = 76;
    public static KEY_M = 77;
    public static KEY_N = 78;
    public static KEY_O = 79;
    public static KEY_P = 80;
    public static KEY_Q = 81;
    public static KEY_R = 82;
    public static KEY_S = 83;
    public static KEY_T = 84;
    public static KEY_U = 85;
    public static KEY_V = 86;
    public static KEY_W = 87;
    public static KEY_X = 88;
    public static KEY_Y = 89;
    public static KEY_Z = 90;
    public static LEFT_META = 91;
    public static RIGHT_META = 92;
    public static SELECT = 93;
    public static NUMPAD_0 = 96;
    public static NUMPAD_1 = 97;
    public static NUMPAD_2 = 98;
    public static NUMPAD_3 = 99;
    public static NUMPAD_4 = 100;
    public static NUMPAD_5 = 101;
    public static NUMPAD_6 = 102;
    public static NUMPAD_7 = 103;
    public static NUMPAD_8 = 104;
    public static NUMPAD_9 = 105;
    public static MULTIPLY = 106;
    public static ADD = 107;
    public static SUBTRACT = 109;
    public static DECIMAL = 110;
    public static DIVIDE = 111;
    public static F1 = 112;
    public static F2 = 113;
    public static F3 = 114;
    public static F4 = 115;
    public static F5 = 116;
    public static F6 = 117;
    public static F7 = 118;
    public static F8 = 119;
    public static F9 = 120;
    public static F10 = 121;
    public static F11 = 122;
    public static F12 = 123;
    public static NUM_LOCK = 144;
    public static SCROLL_LOCK = 145;
    public static SEMICOLON = 186;
    public static EQUALS = 187;
    public static COMMA = 188;
    public static DASH = 189;
    public static PERIOD = 190;
    public static FORWARD_SLASH = 191;
    public static GRAVE_ACCENT = 192;
    public static OPEN_BRACKET = 219;
    public static BACK_SLASH = 220;
    public static CLOSE_BRACKET = 221;
    public static SINGLE_QUOTE = 222
}